var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"data-background-color":_vm.sidebarBackgroundColor}},[_c('user-menu',{on:{"click":_vm.handleClick}}),_c('template',{slot:"links"},[(_vm.assortmentVisible)?_c('sidebar-item',{attrs:{"link":{
                    name: 'Qualidade do Sortimento',
                    icon: 'pie_chart',
                    path: '/assortment'
                }}}):_vm._e(),(_vm.restockingVisible)?_c('sidebar-item',{attrs:{"link":{
                    name: 'Reposição Dinâmica',
                    icon: 'move_to_inbox',
                    path: '/restocking'
                }}}):_vm._e(),(_vm.clustersVisible)?_c('sidebar-item',{attrs:{"link":{
                    name: 'Clusters',
                    icon: 'share',
                    path: '/clusters'
                }}}):_vm._e(),(_vm.nodesVisible)?_c('sidebar-item',{attrs:{"link":{
                    name: 'Árvore de Sortimento',
                    icon: 'account_tree',
                    path: '/nodes'
                }}}):_vm._e(),(_vm.productsVisible)?_c('sidebar-item',{attrs:{"link":{
                    name: 'Produtos',
                    icon: 'local_offer',
                    path: '/products'
                }}}):_vm._e(),(_vm.demandsManagementVisible)?_c('sidebar-item',{attrs:{"link":{
                    name: 'Gestão de Demandas',
                    icon: 'local_offer',
                    path: '/demands-management'
                }}}):_vm._e(),(_vm.restockingManagementVisible)?_c('sidebar-item',{staticClass:"sidebar-item-custom",attrs:{"link":{
                    name: 'Gestão Repos Dinâmica',
                    icon: 'local_shipping',
                    path: '/restocking-product-management'
                }}},[(_vm.restockingManagementVisible)?_c('sidebar-item',{attrs:{"link":{
                        name: 'Produto',
                        icon: 'local_shipping',
                        path: '/restocking-product-management'
                    }}}):_vm._e(),(_vm.restockingManagementVisible)?_c('sidebar-item',{attrs:{"link":{
                        name: 'Loja',
                        icon: 'local_shipping',
                        path: '/restocking-store-management'
                    }}}):_vm._e()],1):_vm._e(),(_vm.salesVisible)?_c('sidebar-item',{attrs:{"link":{
                    name: 'Vendas',
                    icon: 'local_atm',
                    path: '/sales'
                }}}):_vm._e(),(_vm.branchesVisible)?_c('sidebar-item',{attrs:{"link":{
                    name: 'Filiais',
                    icon: 'storefront',
                    path: '/branches'
                }}}):_vm._e(),(_vm.stockVisible)?_c('sidebar-item',{attrs:{"link":{ name: 'Estoque', icon: 'folder', path: '/stock' }}}):_vm._e(),(_vm.usersVisible)?_c('sidebar-item',{attrs:{"link":{ name: 'Usuários', icon: 'people', path: '/users' }}}):_vm._e(),(_vm.clientsVisible)?_c('sidebar-item',{attrs:{"link":{
                    name: 'Clientes',
                    icon: 'tag_faces',
                    path: '/clients'
                }}}):_vm._e(),(_vm.solicitationsVisible)?_c('sidebar-item',{attrs:{"link":{
                    name: 'Pedidos',
                    icon: 'note_alt',
                    path: '/solicitations'
                }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }